import { Options } from 'snq/model';

export function enumToArray(e: any): Options {
  return Object.keys(e)
    .filter((key) => Number.isSafeInteger(e[key]))
    .map((key) => ({ value: key, label: key }));
}
